import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Home = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f4f6f9',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Cercles décoratifs */}
      <div style={{ position: 'absolute', top: '20px', left: '30px', width: '70px', height: '70px', borderRadius: '50%', background: 'rgba(255,255,255,0.1)' }}></div>
      <div style={{ position: 'absolute', top: '70px', left: '90px', width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(255,255,255,0.07)' }}></div>
      <div style={{ position: 'absolute', top: '30px', right: '50px', width: '55px', height: '55px', borderRadius: '50%', background: 'rgba(255,255,255,0.1)' }}></div>
      <div style={{ position: 'absolute', top: '90px', right: '110px', width: '30px', height: '30px', borderRadius: '50%', background: 'rgba(255,255,255,0.07)' }}></div>

      {/* Bande décorative bas */}
      <div style={{
        position: 'absolute',
        bottom: '0',
        left: '0',
        right: '0',
        height: '8px',
        background: 'linear-gradient(90deg, #0d47a1 0%, #1565c0 50%, #1976d2 100%)'
      }}></div>

      {/* Main Card */}
      <div style={{
        background: '#ffffff',
        borderRadius: '25px',
        padding: '50px 60px',
        boxShadow: '0 25px 70px rgba(0, 0, 0, 0.3)',
        border: '3px solid #1565c0',
        position: 'relative',
        zIndex: '1',
        maxWidth: '500px',
        width: '100%'
      }}>
        {/* Bande couleur haut */}
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          height: '6px',
          background: 'linear-gradient(90deg, #0d47a1 0%, #1976d2 50%, #42a5f5 100%)',
          borderRadius: '22px 22px 0 0'
        }}></div>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px', marginTop: '10px' }}>
          <div style={{
            width: '90px',
            height: '90px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #1565c0 0%, #1976d2 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
            boxShadow: '0 6px 20px rgba(21, 101, 192, 0.4)'
          }}>
            <img src="/images/logo-supermont.png" alt="Supermont" style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: "50%" }} />
          </div>
          <h1 style={{
            color: '#0d47a1',
            fontSize: '28px',
            fontWeight: 'bold',
            margin: '10px 0 5px',
            fontFamily: 'Nunito, sans-serif'
          }}>
            Les Perles de Vie
          </h1>
          <p style={{
            color: '#1976d2',
            fontSize: '14px',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '3px',
            margin: 0
          }}>
            Supermont
          </p>
        </div>

        {/* User info */}
        {user && (
          <div style={{
            background: 'linear-gradient(135deg, #e3f2fd 0%, #f5f9ff 100%)',
            borderRadius: '15px',
            padding: '20px 30px',
            marginBottom: '30px',
            border: '2px solid #1976d2',
            boxShadow: '0 4px 15px rgba(21, 101, 192, 0.1)'
          }}>
            <p style={{ margin: '0', fontSize: '16px', color: '#0d47a1', fontWeight: 'bold' }}>
              Connecté en tant que : <span style={{ color: '#1976d2' }}>{user.username}</span>
            </p>
            <p style={{ margin: '5px 0 0', fontSize: '14px', color: '#1565c0' }}>
              Rôle : <strong style={{ color: '#0d47a1' }}>{user.role}</strong>
            </p>
          </div>
        )}

        {/* Actions */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          {user?.role === 'super_admin' || user?.role === 'admin' ? (
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                background: 'linear-gradient(180deg, #1976d2 0%, #1565c0 50%, #0d47a1 100%)',
                border: 'none',
                borderRadius: '15px',
                padding: '18px 30px',
                color: 'white',
                fontSize: '18px',
                fontWeight: 'bold',
                cursor: 'pointer',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                boxShadow: '0 8px 25px rgba(21, 101, 192, 0.4)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            >
              <i className="fas fa-chart-line me-2"></i>DASHBOARD ADMIN
            </button>
          ) : user?.role === 'hotesse' ? (
            <button
              onClick={() => navigate('/hostess')}
              style={{
                background: 'linear-gradient(180deg, #1976d2 0%, #1565c0 50%, #0d47a1 100%)',
                border: 'none',
                borderRadius: '15px',
                padding: '18px 30px',
                color: 'white',
                fontSize: '18px',
                fontWeight: 'bold',
                cursor: 'pointer',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                boxShadow: '0 8px 25px rgba(21, 101, 192, 0.4)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            >
              <i className="fas fa-user-tie me-2"></i>INTERFACE HÔTESSE
            </button>
          ) : null}

          <button
            onClick={handleLogout}
            style={{
              background: 'linear-gradient(180deg, #42a5f5 0%, #1976d2 50%, #1565c0 100%)',
              border: 'none',
              borderRadius: '15px',
              padding: '15px 30px',
              color: 'white',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              textTransform: 'uppercase',
              letterSpacing: '2px',
              boxShadow: '0 6px 20px rgba(21, 101, 192, 0.3)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
          >
            <i className="fas fa-sign-out-alt me-2"></i>DÉCONNEXION
          </button>
        </div>

        {/* Footer */}
        <div style={{ marginTop: '40px', textAlign: 'center' }}>
          <p style={{ color: '#1565c0', fontSize: '13px', margin: '0', fontWeight: 'bold' }}>
            &copy; 2026 SUPERMONT &mdash; Les Perles de Vie
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;
